export default __webpack_public_path__ + "static/media/person.5e3d6b2e.jpg";